module.exports = __webpack_public_path__ + "static/media/purru-icon.5d042e57.png";